import * as React from 'react';
import { Form, Row, Col, Input, Icon, Button, notification } from 'antd';
import FormControl from 'components/Forms/FormControl';
import { FormComponentProps } from 'antd/lib/form';
import { RouteComponentProps, withRouter } from 'react-router';
import { LoginForgetPasswordHandler } from './LoginForgetPasswordFormHandler';
import { NavLink } from 'react-router-dom';
import NotificationUtility from 'Core/NotificationUtility';

export interface Props extends FormComponentProps, RouteComponentProps {
  children?: React.ReactNode;
}

export interface State { }

class BaseLoginForgetPasswordForm extends React.Component<Props, State> {
  loginForgetPasswordHandler: LoginForgetPasswordHandler;
  constructor(props: Props) {
    super(props);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.loginForgetPasswordHandler = new LoginForgetPasswordHandler(props);

    this.state = {};
  }

  onFormSubmit(event: React.FormEvent) {
    event.preventDefault();

    this.props.form.validateFieldsAndScroll((error, values: any) => {
      if (!error) {
        this.loginForgetPasswordHandler
          .SendResetPasswordToken(values.emailAddress)
          .then((x: any) => {
            NotificationUtility.info('Sent verification token to email address', x, 30, true);

            //route to forget password confirmation page after sending token to email 
            this.props.history.push('/forget-password-complete');
          })
          .catch(x => {
            NotificationUtility.error('Error While Sending Email Token', x.message ?? x, 30, true);
          });
      }
    });
  }

  render() {
    const { getFieldDecorator, ...formProps } = this.props.form;
    const InputLayout = {
      labelCol: {
        xs: { span: 24, },
        sm: { span: 24, },
        md: { span: 24, },
        lg: { span: 5, },
        xl: { span: 5, },
      },
      wrapperCol: {
        xs: { span: 22 },
        sm: { span: 22, },
        md: { span: 22, },
        lg: { span: 19, },
        xl: { span: 19, },
      },
    };
    return (
      <Form onSubmit={this.onFormSubmit} {...InputLayout}>
        <Row type="flex" align="middle">
          <Col span={22} offset={1}>
            <h2 style={{ textAlign: 'center' }}>Forgot Password</h2>
            <p>Enter email below to receive your password reset token</p>
          </Col>
        </Row>
        <Row type="flex" align="middle">
          <Col span={22} offset={1}>
            <FormControl
              label="Email"
              getFieldDecorator={getFieldDecorator}
              rules={[
                { required: true, message: 'Please enter your email' },
                { type: 'email', message: 'This input is not a valid email' },
              ]}
              name="emailAddress">
              <Input
                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="Email"
              />
            </FormControl>
          </Col>
        </Row>

        <Row justify="space-between">
          <Col>
            <Row style={{ marginBottom: 8 }}>
              <Col
                xs={{ span: 2, offset: 9 }}
                sm={{ span: 2, offset: 9 }}
                md={{ span: 2, offset: 9 }}
                lg={{ span: 2, offset: 9 }}
                xl={{ span: 2, offset: 9 }}>
                <Button type="primary" htmlType="submit" className="login-form-button">    Send Token </Button>
              </Col>
            </Row>
            <Row>
              <Col span={22} offset={1}>
                <p>
                  Already received your reset token?{' '}
                  <NavLink to="/forget-password-complete">Click Here</NavLink>
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    );
  }
}

const LoginForgetPasswordFormWithoutRoute = Form.create<Props>({
  name: 'LoginForgetPassword',
})(BaseLoginForgetPasswordForm);

const LoginForgetPasswordForm = withRouter(LoginForgetPasswordFormWithoutRoute);

export default LoginForgetPasswordForm;
